
import * as React from 'react'
import { Form, FormLabel } from 'react-bootstrap'
import { Typography, Box, Grid, TextField, Theme } from '@mui/material'
import PackingMaterialsList, { getDefaultPackingMaterials } from '../../../../Settings/PackingMaterialsList'
import NumberFormatCustom from '../../../../../components/NumberFormatCustom'
import { copyObject } from '../../../../../utils'
import _ from 'lodash'
import { createStyles, makeStyles } from '@mui/styles'
import { PackingMaterialsLineItemT } from '../../../../../types/PackingMaterialsT'
import { JobT } from '../../../../../types/Job'
import { useImmer } from 'use-immer'
import LineItemPackingMaterials from './LineItemPackingMaterials'
import NumberFormatValidate from '../../../../../components/NumberFormatValidate'

const defaultPackingMaterials = getDefaultPackingMaterials()

export const useStyles = makeStyles((theme: Theme) => createStyles({
    textFieldAmount: {
        "& .MuiInput-root": {
            "&::before": {
                borderBottomStyle: "solid",
            }
        },
    },

}));





// export interface PackingMaterialsLineItemT {
//     [key: string]: PackingMaterialsValueT
// }
export type IPackingMaterialsProps = {
    job: JobT
    value: Array<PackingMaterialsLineItemT>
    updateValue(items: Array<PackingMaterialsLineItemT>): void
}

const PackingMaterials: React.FunctionComponent<IPackingMaterialsProps> = (props): JSX.Element => {

    const [companyPackingMaterials, setCompanyPackingMaterials] = React.useState(defaultPackingMaterials)
    const [lineItems, setLineItems] = useImmer([]);
    const classes = useStyles()
    const [isReady, setIsReady] = React.useState(false);
    const [isChange, setIsChange] = React.useState(true);

    React.useEffect((): void => {
        if (props.job.companyInfo && props.job.companyInfo.packingMaterials) {
            console.log("PackingMaterials->companyInfo", props.value)
            setCompanyPackingMaterials(props.job.companyInfo.packingMaterials)
        }
        setIsReady(true)
    }, [props.job.companyInfo])



    React.useEffect(() => {
        if (isReady) {
            console.log("PackingMaterials->value", props.value)
            let resolveValue = prepareLineItems(props.value)
            if (!_.isEqual(resolveValue, lineItems)) {
                console.log("PackingMaterials->resolveValue", resolveValue)
                setLineItems(resolveValue)
            }
            setIsChange(false)
        }
    }, [props.value, isReady]);


    /**
     * 
     * @param packingMaterials 
     * @returns 
     */
    const prepareLineItems = (packingMaterials: Array<PackingMaterialsLineItemT>) => {
        if (!_.isArray(packingMaterials)) {
            packingMaterials = getDefaultPackingMaterials()
        }
        return packingMaterials.map((item, index) => {
            return {
                ...item, ...{
                    rate: getRateValue(companyPackingMaterials, copyObject(item))
                }
            }
        })
    }

    const findRateFromCompany = (packingMaterials: Array<PackingMaterialsLineItemT>, item: string): number | null => {
        if (!_.isArray(packingMaterials)) {
            return null
        }
        let findItem = packingMaterials.find((x) => x.item == item)
        if (findItem && _.has(findItem, "rate")) {
            return findItem.rate
        }
        return null
    }


    const getRateValue = (packingMaterials: Array<PackingMaterialsLineItemT>, currentItem: PackingMaterialsLineItemT): number | null => {
        if (_.has(currentItem, "isDirty") && currentItem.isDirty == true) {
            return currentItem.rate
        }
        return findRateFromCompany(packingMaterials, currentItem.item)
    }



    const handleChange = (index: number, key: string, value: any, isDirty: boolean = false) => {
        let cloneItems = copyObject(lineItems)
        cloneItems[index][key] = value
        if (isDirty == true) {
            cloneItems[index]["isDirty"] = true
        }


        setLineItems((draft) => {
            draft[index][key] = value
            if (isDirty == true) {
                draft[index]["isDirty"] = true
            }
            // return draft
        })

        props.updateValue(cloneItems)
    };




    const getTotal = React.useCallback(() => {
        if (_.isArray(lineItems)) {
            return lineItems.reduce((perAmount, item, index) => {
                return Number(perAmount) + (Number(item.quantity) * Number(item.rate))
            }, 0)
        }
        return 0
    }, [lineItems]);


    const packingMaterialsForm = (): Array<JSX.Element> => {

        if (!_.isArray(lineItems)) {
            return null
        }
        return lineItems.map((item, index) => {
            return (
                <LineItemPackingMaterials key={index} item={item} index={index} onChangeValue={handleChange} />
            )
        })

    }
    return (
        <Box>
            <Typography variant="h4" >Details of Packing Materials</Typography>
            <Grid container spacing={3}>
                {packingMaterialsForm()}

                <Grid item xs={12} >
                    <Box style={{ display: 'grid', gridTemplateColumns: 'minmax(200px, 1fr) 4fr 2fr' }}>
                        <Box display="flex" alignItems="center">
                            <Typography>Total</Typography>
                        </Box>
                        <Box>
                        </Box>
                        <Box display="flex" alignItems="flex-end">
                            <Form.Group style={{ width: "100%" }}>
                                <Form.Label>Total, $</Form.Label>
                                <NumberFormatValidate
                                    disabled={true}
                                    customInput={Form.Control}
                                    className="input-material"
                                    type="text"
                                    value={getTotal()}
                                    onValueChange={(values) => {

                                    }}
                                    mask="_"
                                    fixedDecimalScale={true}
                                    decimalScale={2}
                                />
                                {/* <TextField
                                variant="standard"
                                fullWidth
                                disabled
                                value={getTotal()}
                                label="Total"
                                InputProps={{
                                    inputComponent: NumberFormatCustom as any,
                                    inputProps: {
                                        fixedDecimalScale: true,
                                        decimalScale: 2,
                                        mask: "_",
                                        thousandSeparator: true,
                                        prefix: '$'
                                    }
                                }}

                            /> */}
                            </Form.Group>
                        </Box>
                    </Box>
                </Grid>
            </Grid>

        </Box>
    )
}

export default PackingMaterials